import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Cliente } from '@shared/models/precios/Cliente';

@Component({
  selector: 'app-clientes-byr',
  templateUrl: './clientes-byr.component.html',
  styleUrls: ['./clientes-byr.component.css']
})
export class ClientesByrComponent {

  [x: string]: any;


  @Input() clientes: Cliente[];


  busquedaFormControl = new UntypedFormControl();


  cargandoClientes:boolean=true;
  constructor(public activeModal:NgbActiveModal){
  }

}
